import { TFunction } from 'i18next'
import { CancellationType, ContractTypeEnum } from '../types'

const emptyLabel = '-'

export const contractTypeEnumToLabel = (t: TFunction, value: ContractTypeEnum | string | null | undefined): string => {
  if (!value) {
    return emptyLabel
  }
  return t(`contract.typeOfContract.${value}`, { defaultValue: String(value) })
}

export const cancellationTypeToLabel = (t: TFunction, value: CancellationType | string | null | undefined): string => {
  if (!value) {
    return emptyLabel
  }
  return t(`global.employeeCancellationType.${value}`, { defaultValue: String(value) })
}
